<template>
   <div class="main-wrapper">
       <main class="main-content" role="main">
         <h1>Test Boxes </h1>
         <div id="kasten">
            <img src="@/assets/img/eisbecher-gelb.jpg" alt="Dummy-Bild" />

         </div>
         <div id="kasten">
                     <img src="@/assets/img/eisbecher-lila.jpg" alt="Dummy-Bild" />

         </div>
         <div id="kasten">
                     <img src="@/assets/img/eisbecher-rot.jpg" alt="Dummy-Bild" />
         </div>
         <div id="kasten">
                     <img src="@/assets/img/eisbecher-rumtopf.jpg" alt="Dummy-Bild" />

         </div>
       </main>
  </div>
</template>

<script>
export default {
  name: "KastenmodellView",
  data() {
    return {};
  },
  methods: {}
};
</script>

<style scoped>
@import "https://fonts.googleapis.com/css?family=Raleway:500|Roboto:300";
@import "../../assets/css/normalize.css";
@import "../../assets/css/atmosphere.css";
@import "../global/layout.css";

#kasten {
   float: left;
   padding: 10px;
   background: tomato;
   border: 1px solid black;
}
</style>



// WEBPACK FOOTER //
// src/components/examples/kastenmodell.vue